import { useEffect, useState } from "react";
import { fetchHubwayzHotelSaleCommission } from "../../../services/hubwayzHotelCommissionApi";

const UNSET = { type: "percentage", value: 0, status: "unset" };

function normalize(data) {
  const type = data?.hubwayz_hotel_commission_type === "fixed_ils" ? "fixed_ils" : "percentage";
  const value = Number(data?.hubwayz_hotel_commission_value);
  if (!Number.isFinite(value) || value < 0) return { ...UNSET, status: "ok" };
  return { type, value, status: "ok" };
}

/** Logged-in agent's Hubwayz sale commission. Missing or failed load stays at 0. */
export function useHubwayzHotelSaleCommission() {
  const [commission, setCommission] = useState(UNSET);

  useEffect(() => {
    let cancelled = false;
    fetchHubwayzHotelSaleCommission()
      .then((data) => {
        if (!cancelled) setCommission(normalize(data));
      })
      .catch(() => {
        if (!cancelled) setCommission({ ...UNSET, status: "error" });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return commission;
}
